import React from 'react';
import AppSidebar from './AppSidebar';
import AppUserMenu from './AppUserMenu';
import AppMobileNav from './AppMobileNav';
import { useAuth } from '../../contexts/AuthContext';
import '../../styles/UserProfile.css';

export default function AppLayout({ children }) {
  const { currentUser } = useAuth();

  return (
    <div className={`tiktok-page${currentUser ? ' tiktok-page--no-header' : ''}`}>
      <AppSidebar />
      <main className="tiktok-main">
        {currentUser && (
          <div className="app-top-bar">
            <AppUserMenu />
          </div>
        )}
        <div className="app-layout-content">{children}</div>
      </main>
      <AppMobileNav />
    </div>
  );
}
